import api from '@/utils/api';

/**
 * Get all dealers
 * @returns {Promise}
 */
export const getDealerSelect = () => api.get('conf/company-select/dealer');
/**
 * Get all Suppliers
 * @returns {Promise}
 */
export const getSupplierSelect = () => api.get('conf/company-select/supplier');

export default { getDealerSelect, getSupplierSelect };
